import Swal from 'sweetalert2'
import Vuex from './vuex'
import axios from 'axios'

class Api {
	axios = null

    constructor () {}

    call(requestType, url, data = null, opts = {}) {
    	this.axios = axios.create()

		this.axios.defaults.baseURL = `${process.env.VUE_APP_ENGINE_URL}/api`

		this.axios.defaults.headers.common['API-KEY'] = process.env.VUE_APP_PARTNER_API_KEY
		this.axios.defaults.headers.common['X-Session-Key'] = sessionStorage.getItem('session_key')

    	delete this.axios.defaults.headers.common["X-Socket-Id"]

	    return new Promise((resolve, reject) => {
	        this.axios[requestType](url, data, opts)
	            .then(response => {
	                resolve(response)
	            })
	            .catch(({response}) => {
					if(!response) {
						Swal.fire({
							icon: 'error',
							title: 'Erro!',
							text: 'Ocorreu um erro ao realizar sua solicitação. Contate o suporte!'
						})

						reject()
					}

	                if([401, 418].indexOf(response.status) > -1)  {
	                	new Vuex().dispatch('auth/Logout')
	                		.finally(() => {
	                			reject(response)
	                		})
	                }

	                resolve(response)
	            });
	    });
	}
}

export default Api;